module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-loader u-fixed u-pos-tl u-zindex--52 u-flex u-flex-ai--center u-flex-jc--center u-fit u-bg--brand-primary u-overflow-h",
    class: [_vm.isActive ? 'is-active' : '', 'is-active-index-' + _vm.activeIndexHome]
  }, [_c('div', {
    staticClass: "c-loader__logotype u-absolute u-pos-center"
  }, [_c('app-icon', {
    staticClass: "c-loader__logotype__p  u-absolute u-pos-center u-fill--white u-stroke--white",
    attrs: {
      "name": "logotype-p"
    }
  }), _vm._v(" "), _c('app-icon', {
    staticClass: "c-loader__logotype__outline u-absolute u-pos-center u-fill--white u-stroke--white",
    attrs: {
      "name": "logotype-outline"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-loader__text u-color--white u-uppercase t-fweight--bold"
  }, [_vm._v("Prax")]), _vm._v(" "), _c('div', {
    staticClass: "c-loader__percent u-absolute u-pos-r-vw1of12 u-color--white t-ffamily--simplon t-fweight--light"
  }, [_c('span', [_vm._v(_vm._s(_vm.percent))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8611e38"}!./src/scripts/components/app-loader/template.html
// module id = 483
// module chunks = 0